<template>
    <cadastro-simples-list
        endpoint="tipo-renda-familiar"
        rota-base="/admin/tipo-renda-familiar"
        titulo="TIPOS DE RENDA FAMILIAR"
        titulo-singular="Tipo de Renda Familiar"
        :colunas-extras='[{"campo":"valor_minimo","label":"Valor mínimo (R$)","tipo":"string"},{"campo":"valor_maximo","label":"Valor máximo (R$)","tipo":"string"},{"campo":"ordem","label":"Ordem","tipo":"int"}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
